import { useMutation } from '@cbgms/base/http/use-query'
import { DuplicationCheck } from '@cbgms/api'
import { useDuplicateCheckSignupCredentials } from 'app/auth/components/hooks/use-duplicate-checks'

export interface CredentialsValidatorSchema {
  loginEmail: string
}

// useSignupCredentialsValidatorBuilder builds a usMutation that can used in your components
export const useSignupCredentialsValidatorBuilder = (duplicateChecks: DuplicationCheck[], basePath: string) => {
  const handleDuplicateCheckSignupCredentials = useDuplicateCheckSignupCredentials(duplicateChecks, basePath)

  return useMutation<void, unknown, { loginEmail: string }>(async ({ loginEmail }) => {
    await handleDuplicateCheckSignupCredentials(loginEmail)
  })
}
